// src/extended-fetch/ApiError.ts
var ApiError = class _ApiError extends Error {
  constructor({
    message,
    stack,
    status,
    statusText,
    errorCode,
    exception
  }) {
    super(message);
    Object.setPrototypeOf(this, _ApiError.prototype);
    this.stack = stack;
    this.status = status;
    this.errorCode = errorCode;
    this.exception = exception;
    this.statusText = statusText;
  }
  status;
  statusText;
  errorCode;
  exception;
};
export {
  ApiError as default
};
